import React, { Fragment } from 'react';
import { USER_ROLES } from '../../../utils/constants';
import { LeftMenuUser } from './LeftMenuUser';
import { CurrentUserLimits } from '../../../slices/current-user/current-user.state';
import { AdminMenu } from './roles/AdminMenu';
import { PracticeOwnerMenu } from './roles/PracticeOwnerMenu';
import { SecondaryUserMenu } from './roles/SecondaryUserMenu';
import { UserMenu } from './roles/UserMenu';
import { CharityAdminMenu } from './roles/CharityAdminMenu';

export interface RoleMenuSwitcherProps {
    user: LeftMenuUser;
    limits: CurrentUserLimits;
}

export const RoleMenuSwitcher = (props: RoleMenuSwitcherProps) => {
    const { user, limits } = props;

    switch (user.roleId) {
        case USER_ROLES.ADMIN:
            return <AdminMenu />;
        case USER_ROLES.PRACTICE_OWNER:
            return <PracticeOwnerMenu user={user} limits={limits} />;
        case USER_ROLES.PRACTICE_SECONDARY_USER:
            return <SecondaryUserMenu user={user} limits={limits} />;
        case USER_ROLES.USER:
            return <UserMenu user={user} limits={limits} />;
        case USER_ROLES.CHARITY_ADMIN:
            return <CharityAdminMenu user={user} limits={limits} />;
        default:
            return <Fragment />;
    }
};
